import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IShippingProvider } from "../models/ShippingProvider";
import { DefaultResponseWithData } from "../models/system";
import { useEffect, useState } from "react";

export default function useShippingProviders(selectedProvider?: string) {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();
  const [isValidating, setIsValidating] = useState(true);
  const [valid, setValid] = useState(false);
  const staleTime = 1000 * 60 * 10; // 10 minutes

  useEffect(() => {
    // Simulate validation logic
    setTimeout(() => {
      setValid(true);
      setIsValidating(false);
    }, 1000);
  }, []);

  const shippingProviders = useQuery(
    ["shippingProviders"],
    () => get<DefaultResponseWithData<IShippingProvider[]>>("/shipping/providers"),
    {
      enabled: valid && !isValidating,
      staleTime: staleTime,
    }
  );

  // fetch settings for whichever provider is selected
  const providerSettings = useQuery(
    ["providerSettings", selectedProvider],
    () =>
      get<DefaultResponseWithData<any>>(
        `/shipping/settings?service=${encodeURIComponent(selectedProvider!)}`
      ),
    {
      // only run if there's actually a provider
      enabled: !!selectedProvider,
      staleTime: staleTime,
    }
  );

  const updateSettings = useMutation(
    (data: any) => post("/shipping/settings", data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["providerSettings"]);
        queryClient.invalidateQueries(["shippingProviders"]);
      },
    }
  );

  return {
    shippingProviders,
    providerSettings,
    updateSettings,
    isValidating,
    valid,
  };
}